module.exports = __webpack_public_path__ + "img/add_remark_af.07af8ae3.svg";